var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRouter = function SvgRouter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1115",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M77.773 185.12h201.76c5.83 0 10.469 6.659 14.752 10.583l49.489 45.422c4.283 3.924-4.759 10.583-10.588 10.583H24.596c-5.83 0-14.871-6.54-10.588-10.583l49.013-45.422c4.164-3.924 8.922-10.583 14.752-10.583"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.528 260.86h318.82c5.83 0 10.588 4.756 10.588 10.583v35.077c0 5.826-4.759 10.583-10.588 10.583H18.528c-5.83 0-10.588-4.756-10.588-10.583v-35.077c0-5.826 4.759-10.583 10.588-10.583m36.76 18.787c4.878 0 8.922 4.043 8.922 8.918 0 4.994-4.045 8.918-8.922 8.918-4.997 0-8.922-3.924-8.922-8.918 0-4.875 3.925-8.918 8.922-8.918m41.281 0c4.996 0 8.922 4.043 8.922 8.918 0 4.994-3.926 8.918-8.922 8.918-4.878 0-8.922-3.924-8.922-8.918 0-4.875 4.044-8.918 8.922-8.918m41.162 0c4.878 0 8.922 4.043 8.922 8.918 0 4.994-4.044 8.918-8.922 8.918-4.996 0-8.922-3.924-8.922-8.918 0-4.875 3.925-8.918 8.922-8.918m41.519 0c4.878 0 8.922 4.043 8.922 8.918 0 4.994-4.044 8.918-8.922 8.918s-8.922-3.924-8.922-8.918c0-4.875 4.044-8.918 8.922-8.918m36.165 5.113h97.551v7.61h-97.551z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m65.519 37.56 43.303 148.75H88.598L52.671 38.51c-1.784-8.918 10.826-10.583 12.848-.951z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m289.65 37.56-43.422 148.75h20.343l35.927-147.8c1.785-8.918-10.826-10.583-12.848-.951z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M171.99 24.48a88.4 88.4 0 0 0-36.998 11.296c-6.424 3.805-27.719 16.29-19.272 25.208 6.781 7.134 12.967-3.21 22.246-9.275 2.617-1.783 4.878-3.091 7.852-4.518 28.076-13.555 59.72-9.513 82.56 10.702 1.666 1.427 4.402 4.637 7.138 5.113 7.614 1.546 12.015-7.016 6.662-12.842-16.536-17.717-44.493-27.586-70.189-25.684z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M176.87 64.314c11.183-.595 20.581 2.616 28.551 7.372 4.878 2.973 8.209 6.897 9.993 7.967 4.759 2.972 9.993 0 11.183-3.924 1.903-6.183-3.45-9.275-5.948-11.534-17.726-15.933-47.943-19.619-69.237-8.799-5.116 2.497-18.558 10.345-19.867 15.933-1.309 5.589 2.974 9.988 8.09 9.394 6.542-.595 12.728-15.22 37.235-16.41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M174.25 89.641c7.257-1.665 13.8.357 18.796 3.567 2.141 1.546 4.045 4.162 6.9 4.994 3.807.951 6.78-1.07 8.208-3.091 4.878-7.016-3.568-12.01-6.78-14.388-10.47-7.135-25.22-8.918-37.118-3.924-25.458 10.702-13.68 24.019-5.472 21.284 4.402-1.546 4.64-6.065 15.465-8.443z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path1129",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M166.52 115.8c2.26 15.696 27.838 13.317 25.339-4.043-2.38-16.409-27.957-13.317-25.339 4.043"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRouter);
export default ForwardRef;